<template>
  <div class="footer-menu">
    <router-link to="/" class="menu-item" active-class="active">
      <span>🎖️</span>
      Claim
    </router-link>
    <router-link to="/tasks" class="menu-item" active-class="active">
      <span>📝</span>
      Tasks
    </router-link>
    <router-link to="/referral" class="menu-item" active-class="active">
      <span>🔗</span>
      Referral
    </router-link>
    <router-link to="/settings" class="menu-item" active-class="active">
      <span>⚙️</span>
      Settings
    </router-link>

    <a href="https://bitherin.com" class="menu-item" target="_blank">
      <span> 🌐 </span>
      Bitherin
    </a>

  </div>
</template>

<script>
export default {
  name: 'FooterMenu'
}
</script>

<style scoped>
.footer-menu {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #040C14;
  padding: 10px 0;
  color: #fff;
  display: flex;
  justify-content: space-around;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.menu-item {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px;
  transition: background-color 0.3s, color 0.3s, border-radius 0.3s;
}

.menu-item:hover {
  background-color: #333;
  color: #ffa500;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.menu-item.active {
  background-color: #000;
  color: #ffa500;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.active {
  color: #ffa500;
}
</style>
